import React from 'react'
import { Ordering } from 'storfox-filter'

import { BUCKET_COLUMNS as tableColumns } from './BucketTable'

import { FILTER_NAME as name } from '../../constants'

export const bucketOrderingOptions = {
  name,
  tableColumns
}

function BucketOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default BucketOrderingForm
